import styled from "styled-components";


export const StyledTetris = styled.div`
	display: flex;
	align-items: flex-start;
	margin: auto;
	margin-top: 15px;
	width: 630px;

	aside {
		width: 100%;
		max-width: 200px;
		display: block;
		padding: 0 20px;
	}
`;